// ¿EL AVISO «HAY UNA VERSIÓN NUEVA» HABLA DE LA QUE YA TENGO? · DIRECTRIZ-PWA
// F1, corrección P1-2 (11 oct 2026).
//
// Desde que el build sella sw.js por paquete, cada despliegue instala un
// worker nuevo también en la pestaña que acaba de cargar la versión nueva.
// El worker manda en su aviso la versión que instaló (la de precache.json);
// la pestaña la compara con la suya (`__TEGO_VERSION__`, sellada en el
// paquete) y, si coinciden, no hay nada que recargar. Sin versión en el
// aviso (worker anterior, lista que no llegó) se avisa igual: lo prudente.
export const ESPERA_AVISO_MS = 3000;

export function esLaVersionDeEstaPestana(version, deEstaPestana = versionDeEstaPestana()) {
  return !!version && !!deEstaPestana && version === deEstaPestana;
}

export function versionDeEstaPestana() {
  return typeof __TEGO_VERSION__ !== 'undefined' ? String(__TEGO_VERSION__) : '';
}
